import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { TableCell } from "@mui/material";
import { TableRow } from "@mui/material";
import Paper from "@mui/material/Paper";

import { useState } from "react";
import Loading from "../component/Loading";
// import PassReset from '../component/PassReset'
import { useMediaQueryContext } from "../component/MediaQueryProvider";
import { LoginUserAtom } from "../stores/LoginUserAtom";
import { useRecoilValue } from "recoil";
import { ItemRecoilState } from "../stores/ItemAtom";

const MyProfile = () => {
  const [passResetOpen, setPassResetOpen] = useState(false);

  const itemRecoilData = useRecoilValue(ItemRecoilState);
  const loginUserData = useRecoilValue(LoginUserAtom);

  const { isMobileSite } = useMediaQueryContext();

  const currentUser: any = itemRecoilData.user;

  const userId = currentUser?.user_id?.toString() ?? "";

  const userName = currentUser?.name ?? loginUserData.userName;

  const userMail = currentUser?.email ?? loginUserData.email;

  const userAuthority = currentUser?.authority_name ?? "";

  return (
    <>
      {isMobileSite ? (
        <>
          <Paper elevation={3} sx={{ width: "auto", margin: 2 }}>
            <Table aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ fontSize: "0.75rem" }}
                  >
                    ユーザーID
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.75rem" }}>{userId}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ fontSize: "0.75rem" }}
                  >
                    ユーザー名
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.75rem" }}>{userName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ fontSize: "0.75rem" }}
                  >
                    メールアドレス
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.75rem" }}>{userMail}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ fontSize: "0.75rem" }}
                  >
                    権限
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.75rem" }}>
                    {userAuthority}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
          {/*           <Grid container>
            <Grid item sx={{ textAlign: 'center', m: 1 }} xs={12}>
              {currentUser?.employmentStatusId != 6 ? (
                <Button
                  onClick={() => {
                    setPassResetOpen(true)
                  }}
                  variant="contained"
                  color="primary"
                  sx={{ fontSize: '0.75rem' }}
                >
                  パスワードの更新
                </Button>
              ) : null}
            </Grid>
          </Grid> */}
        </>
      ) : (
        <>
          <Paper elevation={3} sx={{ width: "auto", margin: 2 }}>
            <Table aria-label="simple table">
              {/* <TableHead>
              <TableRow>
                <TableCell />
              </TableRow>
            </TableHead> */}
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">
                    ユーザーID
                  </TableCell>
                  <TableCell>{userId}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    ユーザー名
                  </TableCell>
                  <TableCell>{userName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    メールアドレス
                  </TableCell>
                  <TableCell>{userMail}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    権限
                  </TableCell>
                  <TableCell>{userAuthority}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>

          {/*           <Grid container>
            <Grid item sx={{ textAlign: 'center', m: 1 }} xs={12}>
              {currentUser?.employmentStatusId != 6 ? (
                <Button
                  onClick={() => {
                    setPassResetOpen(true)
                  }}
                  variant="contained"
                  color="primary"
                  sx={{ fontSize: '1rem' }}
                >
                  パスワードの更新
                </Button>
              ) : null}
            </Grid>
          </Grid> */}

          {/*           <Dialog
            open={passResetOpen}
            //ダイアログ外をクリックしたときに閉じる
            // onClose={() => {
            //   setPassResetOpen(false)
            // }}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <PassReset setPassResetOpen={setPassResetOpen} />
          </Dialog> */}
        </>
      )}
    </>
  );
};

export default MyProfile;
